<nz-layout>
    <nz-header class="section-header">
        {{ "Cognitive Assessment" | translate }}
    </nz-header>
    <nz-content>
        <ng-container>
            <survey [model]="model" style="position: relative; top: 0; left: 0; right: 0; bottom: 0;"></survey>
        </ng-container>
    </nz-content>
</nz-layout>